import { ArrowRightOnRectangleIcon, InformationCircleIcon } from '@heroicons/react/24/outline/index.js';
import { INavConfigMobileTablet } from '@pendwa/common-browser/components/Navs/Nav/types.js';
import { IContextPageDataViewer } from '@pendwa/common-browser/context/PageData/index.js';
import { rootRoutes } from '@pendwa/common/core/rootRoutes/index.js';
import { filterOutNullOrUndefined } from '@pendwa/common/utils/isDefinedAndNotNull.js';
import { moreLinks } from '../links/more.js';

export const linksMobileTablet = (params: { viewer?: IContextPageDataViewer }): INavConfigMobileTablet => {
  return {
    main: {
      link: {
        label: browserRootConfig.project.name,
        navigate: {
          description: 'Home page.',
          href: domain_env_pendwa_app
            ? rootRoutes.shows.main.get()
            : domain_env_africacrosswords_com
              ? rootRoutes.crosswords.main.get()
              : domain_env_swiftcomment_com
                ? rootRoutes.sc.main.get()
                : domain_env_pendwa_org
                  ? rootRoutes.console.main.get()
                  : rootRoutes.home.main.get(),
        },
      },
    },
    right_section: {
      show_sign_in_up: !params.viewer,
      children: filterOutNullOrUndefined([
        domain_env_pendwa_app
          ? {
              label: 'Shows',
              navigate: {
                description: 'All Shows.',
                href: rootRoutes.shows.main.get(),
              },
            }
          : undefined,
        domain_env_africacrosswords_com
          ? {
              label: 'Crosswords',
              navigate: {
                description: 'All Crosswords.',
                href: rootRoutes.shows.main.get(),
              },
            }
          : undefined,
        domain_env_swiftcomment_com
          ? {
              label: 'Dashboard',
              navigate: {
                description: `${browserRootConfig.project.name} dashboard.`,
                href: rootRoutes.sc.main.get(),
              },
            }
          : undefined,
        params.viewer
          ? {
              label: 'Settings',
              navigate: {
                description: 'Your account settings.',
                href: rootRoutes.settings.main.get(),
              },
            }
          : undefined,
        {
          label: 'Help and Support',
          navigate: {
            description: `Get help with ${browserRootConfig.project.name}.`,
            href: browserRootConfig.project.help_url,
          },
          icon: InformationCircleIcon,
        },
        params.viewer
          ? {
              label: 'Logout',
              navigate: {
                description: 'Sign out of your account.',
                href: rootRoutes.app.logout.main.get(),
              },
              icon: ArrowRightOnRectangleIcon,
            }
          : undefined,
        {
          label: 'More',
          links: moreLinks(params),
        },
      ]),
    },
  };
};
